import { render, staticRenderFns } from "./ProjectListItemOpenState.vue?vue&type=template&id=3891ad66&scoped=true"
import script from "./ProjectListItemOpenState.vue?vue&type=script&lang=ts"
export * from "./ProjectListItemOpenState.vue?vue&type=script&lang=ts"
import style0 from "./ProjectListItemOpenState.vue?vue&type=style&index=0&id=3891ad66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891ad66",
  null
  
)

export default component.exports